import { Record } from 'immutable';
export default class AssociationDefinition extends Record({
  allowsCustomLabels: null,
  cardinality: null,
  category: null,
  fromObjectTypeId: null,
  fromObjectType: null,
  toObjectType: null,
  hasAllAssociatedObjects: null,
  hasCascadingDeletes: null,
  id: null,
  inverseCardinality: null,
  inverseId: null,
  isInversePrimary: null,
  inverseName: null,
  inverseLabel: null,
  inverseHasAllAssociatedObjects: null,
  inverseAllowsCustomLabels: null,
  maxToObjectIds: null,
  maxFromObjectIds: null,
  isPrimary: null,
  label: null,
  name: null,
  toObjectTypeId: null,
  hidden: false,
  isDefault: false
}, 'AssociationDefinition') {}